import React, { useEffect, useRef } from 'react';
import AMapLoader from '@amap/amap-jsapi-loader';
import './Contact.css';

const Contact = () => {
  const mapRef = useRef(null);

  useEffect(() => {
    let map = null;

    const initAMap = () => {
      if (!window.AMap) {
        return;
      }

      try {
        const mapElement = document.getElementById('map');

        if (!mapElement) {
          return;
        }

        // 芜湖市湾沚区新芜经济开发区工业大道1887号坐标
        map = new window.AMap.Map('map', {
          zoom: 15,
          center: [118.596254, 31.162395],
          viewMode: '2D'
        });

        const toolBar = new window.AMap.ToolBar({
          position: {
            right: '5px',
            top: '10px'
          }
        });
        map.addControl(toolBar);

        const scale = new window.AMap.Scale();
        map.addControl(scale);

        const marker = new window.AMap.Marker({
          position: [118.596254, 31.162395],
          title: '巨隆液压设备（集团）有限公司'
        });
        map.addOverlay(marker);

        const infoWindow = new window.AMap.InfoWindow({
          content: '<div style="padding:10px;"><strong>巨隆液压设备（集团）有限公司</strong><br/>安徽省芜湖市湾沚区新芜经济开发区工业大道1887号</div>',
          offset: new window.AMap.Pixel(0, -30),
          position: [118.596254, 31.162395]
        });

        marker.on('click', () => {
          infoWindow.open(map, marker.getPosition());
        });

        infoWindow.open(map, [118.596254, 31.162395]);

        mapRef.current = map;
      } catch (error) {
        console.error('地图初始化失败:', error);
      }
    };

    window._AMapSecurityConfig = {
      securityJsCode: '8bfb1e7dfee167d36aa2fd2788fd4e61',
    };

    AMapLoader.load({
      key: 'bd497fc0ab4355c3bb00edc658d0d193',
      version: '2.0',
      plugins: ['AMap.ToolBar', 'AMap.Scale']
    })
      .then((AMap) => {
        initAMap();
      })
      .catch((e) => {
        console.error('高德地图加载失败:', e);
      });

    return () => {
      if (map) {
        map.destroy();
        map = null;
      }
    };
  }, []);

  return (
    <>
      {/* 公司信息 */}
      <section className="contact-info-section section" style={{ backgroundColor: '#f5f5f5' }}>
        <div className="contact-section">
          <div className="contact-section-left">
            <div className="contact-left-image">
              <img src="/images/contact.jpg" alt="公司厂房"/>
            </div>
          </div>

          <div className="contact-section-right">
            <div className="contact-right-content">
              <h2>巨隆液压设备（集团）有限公司</h2>
              <p>地址：安徽省芜湖市湾沚区新芜经济开发区工业大道1887号</p>
              <div className="contact-info-list">
                <div className="contact-info-item">
                  <span className="info-label">联系电话：</span>
                  <p><a href="tel:0739-5130854">0553-8768888</a></p>
                </div>
                <div className="contact-info-item">
                  <span className="info-label">公司传真：</span>
                  <p>0553-8767767</p>
                </div>
                <div className="contact-info-item">
                  <span className="info-label">电子邮箱：</span>
                  <p><a href="mailto:julongjituan@163.com">julongjituan@163.com</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 地图组件 */}
      <section className="contact-map-section">
        <div className="contact-section">
          <div className="contact-map-container">
            <div
              id="map"
              style={{ width: '100%', height: '450px' }}
            ></div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
